module.exports = __webpack_public_path__ + "img/logo.db5fbec1.svg";